<span [style.display]="!showroomMode ? 'block' :'none'" class="mt-1">
  <ng-content></ng-content>
  @if (price && price.value !== 0) {
    <ng-content></ng-content>@if (showLabel && !hasDifferentPrices) {
    {{ 'NETPRICE' | translate }}
  }
  @if (hasDifferentPrices || showFrom) {
    {{ 'FROM_MIN_PRICE' | translate }}
  }
  <span class="text-nowrap" [innerHTML]="price.value |  currencyConvert: price.currency"></span>
  @if (article?.promotion_price && article?.promotion_price.discount && !article?.setitem && !article?.volume_price?.length) {
    <span class="discount rounded p-1 ms-1 mt-3 text-nowrap" style="line-height: initial;">{{"DISCOUNT"|translate}} {{numberFormat.removeDecimals(article?.promotion_price?.discount)}}%</span>
  }
  @if (article?.promotion_price && !article?.promotion_price.discount && !article?.setitem && !article?.volume_price?.length) {
    <span class="discount rounded p-1 ms-1 mt-3 text-nowrap" style="line-height: initial;">{{"PROMOTION"|translate}}</span>
  }
  @if (vatText) {
    <small class="d-block">{{vatText}}</small>
  }
}
@if (!price && loading) {
  <div class="spinner-border text-primary spinner-border-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
}
</span>